import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetOffersCargosParams } from "../model";

export const useGetOffersCargos = (
  params: GetOffersCargosParams,
  options?: QueryOptions<typeof FreightMatching.useGetOffersCargos>,
): UseQueryResult<FreightMatching.GetOffersCargosQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getOffersCargos", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getOffersCargos(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetOffersCargosQueryResult,
    undefined
  >;
};

export const useMultipleGetOffersCargos = (
  paramsList: { [key: string | number]: GetOffersCargosParams },
  options?: QueryOptions<typeof FreightMatching.useGetOffersCargos> & {
    sortFunc?: (a: GetOffersCargosParams, b: GetOffersCargosParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetOffersCargosQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getOffersCargos", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getOffersCargos(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetOffersCargosQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetOffersCargosMock = (
//   params: GetOffersCargosParams,
//   options?: QueryOptions<typeof FreightMatching.useGetOffersCargos>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetOffersCargosMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetOffersCargos(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetOffersCargosMock = (
//   paramsList: { [key: string | number]: GetOffersCargosParams },
//   options?: QueryOptions<typeof FreightMatching.useGetOffersCargos>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetOffersCargosMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetOffersCargos(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
